import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "../../libs/axios";
import { IPublicWebinars } from "../../models/interfaces/IWebinar.interface";

export function useGetWebinars({ enabled }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["webinars"],
    queryFn: async (): Promise<IPublicWebinars> => {
      const { data } = await axios.get("/public-webinar?type=upcoming", {});
      return data?.data;
    },
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
}
export function useAddPublicAttandee() {
  return useMutation({
    mutationFn: (payload: any) => {
      return axios.post(`/public-webinar/add-attendee`, payload);
    },
  });
}
